import React, { createContext, useState } from 'react';

export const DownloadCSVContext = createContext();

export function DownloadCSVProvider({ children }) {
  const [csvDataGenerator, setCsvDataGenerator] = useState();
  const [transactionTotalPages, setTransactionTotalPages] = useState(0);
  const [lastLoadedPage, setLastLoadedPage] = useState(1);
  const [currentTransactions, setCurrentTransactions] = useState([]);
  const [companyName, setCompanyName] = useState('');

  return (
    <DownloadCSVContext.Provider
      value={{
        csvDataGenerator,
        setCsvDataGenerator,
        transactionTotalPages,
        setTransactionTotalPages,
        lastLoadedPage,
        setLastLoadedPage,
        currentTransactions,
        setCompanyName,
        companyName,
        setCurrentTransactions
      }}
    >
      {children}
    </DownloadCSVContext.Provider>
  );
}
